import PropTypes from "prop-types";
import * as React from "react";

const Button = ({
  className = "",
  color = "primary",
  disabled = false,
  icon,
  loading = false,
  onClick,
  size = "sm",
  type = "submit",
  children,
  RootComponent,
  to = null,
}) => {
  const colorMap = {
    primary: {
      color: "bg-white",
      hover: "hover:bg-empower-500 hover:shadow-lg hover:text-white",
      text: "text-xs text-empower-500",
      padding: "py-2 px-4",
    },
    secondary: {
      color: "bg-gray-300",
      hover: "hover:bg-gray-200",
      text: "text-xs text-gray-800",
      padding: "py-2 px-4",
    },
    danger: {
      color: "bg-red-700",
      hover: "hover:bg-red-600",
      text: "text-xs text-white",
      padding: "py-2 px-4",
    },
    success: {
      color: "bg-green-700",
      hover: "hover:bg-green-600",
      text: "text-xs text-white",
      padding: "py-2 px-4",
    },
    login: {
      color: "bg-empower-500",
      hover: "hover:bg-empower-300",
      text: "text-sm text-white",
      padding: "py-3",
    },
  };

  const btn = (
    <button
      className={`${colorMap[color].color} ${colorMap[color].hover} ${
        colorMap[color].text
      } ${
        colorMap[color].padding
      } flex justify-center items-center font-bold rounded-lg shadow-md uppercase ${className} ${
        disabled || loading ? " opacity-50 cursor-not-allowed" : ""
      }`}
      disabled={disabled || loading}
      onClick={onClick}
      type={type}
    >
      {loading ? "Loading" : children}
    </button>
  );

  if (RootComponent) {
    return <RootComponent to={to}>{btn}</RootComponent>;
  }
  return btn;
};

Button.propTypes = {
  children: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  disabled: PropTypes.bool,
  icon: PropTypes.string,
  loading: PropTypes.bool,
  onClick: PropTypes.func,
  size: PropTypes.string,
  type: PropTypes.string,
};

export default Button;
